import React from "react";

import { ImagePreview } from "@/components";
import "./EditImageModal.css";

interface EditImageModalProps {
  isOpen: boolean;
  onClose: () => void;
  pendingPhoto: File | null;
  onImageChange: (file: File | null) => void;
  onValidationChange: (isValid: boolean) => void;
}

const EditImageModal: React.FC<EditImageModalProps> = ({
  isOpen,
  onClose,
  pendingPhoto,
  onImageChange,
  onValidationChange,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content-edit-image">
        <button className="modal-close" onClick={onClose}>
          &times;
        </button>

        <div className="modal-body">
          <div className="step-content">
            <ImagePreview
              value={pendingPhoto}
              onChange={onImageChange}
              isValid={onValidationChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditImageModal;
